"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfManualClearanceDto = instanceOfManualClearanceDto;
exports.ManualClearanceDtoFromJSON = ManualClearanceDtoFromJSON;
exports.ManualClearanceDtoFromJSONTyped = ManualClearanceDtoFromJSONTyped;
exports.ManualClearanceDtoToJSON = ManualClearanceDtoToJSON;
exports.ManualClearanceDtoToJSONTyped = ManualClearanceDtoToJSONTyped;
/**
 * Check if a given object implements the ManualClearanceDto interface.
 */
function instanceOfManualClearanceDto(value) {
    return true;
}
function ManualClearanceDtoFromJSON(json) {
    return ManualClearanceDtoFromJSONTyped(json, false);
}
function ManualClearanceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'provider': json['provider'] == null ? undefined : json['provider'],
    };
}
function ManualClearanceDtoToJSON(json) {
    return ManualClearanceDtoToJSONTyped(json, false);
}
function ManualClearanceDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'provider': value['provider'],
    };
}
//# sourceMappingURL=ManualClearanceDto.js.map